import { NgComponentOutlet, NgTemplateOutlet } from '@angular/common';
import { Component, OnInit, TemplateRef, Type, inject } from '@angular/core';
import { MyOverlayRef } from './myoverlay-ref';

@Component({
  selector: 'app-overlay',
  templateUrl: './overlay.component.html',
  imports: [NgTemplateOutlet, NgComponentOutlet],
})
export class OverlayComponent implements OnInit {
  private ref = inject(MyOverlayRef);

  public contentType: 'template' | 'string' | 'component';
  public content: TemplateRef<any>;
  public content2: Type<any>;
  public context: any;

  ngOnInit() {
    this.content = this.ref.content;

    if (typeof this.content === 'string') {
      this.contentType = 'string';
    } else if (this.content instanceof TemplateRef) {
      this.contentType = 'template';
      this.context = {
        close: this.ref.close.bind(this.ref),
      };
    } else {
      this.contentType = 'component';
      this.content2 = this.ref.content as unknown as Type<any>;
    }
  }

  close() {
    this.ref.close(null);
  }
}
